export const menuData = ["home", "about", "portfolio", "skills", "contact"];
